"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const gx_1 = require("@kyruus/gx");
const prop_types_1 = require("prop-types");
const xstate_1 = require("xstate");
const react_2 = require("@xstate/react");
const framer_motion_1 = require("framer-motion");
const intl_1 = require("@kyruus/intl");
const appointment_info_1 = require("@kyruus/appointment-info");
const messages_1 = __importDefault(require("../../lib/messages"));
const useWindowWidth_1 = __importDefault(require("../../lib/useWindowWidth"));
const VisitTypes_1 = require("../../lib/constants/VisitTypes");
const States_1 = require("../../lib/constants/States");
const Actions_1 = require("../../lib/constants/Actions");
const styles_1 = require("./styles");
const utils_1 = require("../../lib/utils");
const configUtils_1 = require("../../lib/configUtils");
const Banners_1 = require("../Banners");
const NextBtn_1 = __importDefault(require("./NextBtn"));
const Recaptcha_1 = require("../Recaptcha");
const EmergencyDisclaimer_1 = __importDefault(require("./EmergencyDisclaimer"));
const Tracking_1 = require("../../lib/constants/Tracking");
const MountScroller_1 = __importDefault(require("../Util/MountScroller"));
const gx_handlers_1 = require("./gx-handlers");
const RecaptchaErrorModal_1 = __importDefault(require("../Recaptcha/RecaptchaErrorModal"));
const provider_components_1 = require("@kyruus/provider-components");
const utils_apptInfo_1 = require("./utils.apptInfo");
/**
 * @param {StateNode} state
 * @returns {Object} empty object or object contiaining <eventName, eventData>
 */
const getTrackingByState = (state) => {
    const states = {
        [`${States_1.apptQuestions}.${States_1.apptPatientRel}.${States_1.noAvailability}`]: () => ({
            eventName: Tracking_1.pageEvents.APPOINTMENT_REASON,
            eventData: { mode: Tracking_1.appointmentPurposeModes.NO_AVAIL_PATIENT_REL_ERR }
        }),
        [`${States_1.apptQuestions}.${States_1.apptPurpose}.${States_1.noAvailability}`]: () => ({
            eventName: Tracking_1.pageEvents.APPOINTMENT_REASON,
            eventData: { mode: Tracking_1.appointmentPurposeModes.NO_AVAIL_PURPOSES_ERR }
        }),
        [`${States_1.apptQuestions}.${States_1.apptPurpose}.${States_1.noResults}`]: () => ({
            eventName: Tracking_1.pageEvents.APPOINTMENT_REASON,
            eventData: { mode: Tracking_1.appointmentPurposeModes.NO_PURPOSES_ERR }
        }),
        [`${States_1.apptQuestions}.${States_1.apptPurpose}.${States_1.idle}`]: () => ({
            eventName: Tracking_1.pageEvents.APPOINTMENT_REASON,
            eventData: { mode: Tracking_1.appointmentPurposeModes.PURPOSES_DROPDOWN }
        })
    };
    for (const key in states) {
        if (state.matches(key)) {
            return states[key]();
        }
    }
    return {};
};
/**
 * Appt purpose section should be visible if
 * - we're in any appt purpose state except for `noResults`
 * - we're in the conditionalGxQuestions state
 * - we're in the apptInfoComplete state
 * @param {StateNode} state
 * @returns {Boolean}
 */
const shouldShowApptPurpose = (state) => (state.matches(`${States_1.apptQuestions}.${States_1.apptPurpose}`) &&
    !state.matches(`${States_1.apptQuestions}.${States_1.apptPurpose}.${States_1.noResults}`)) ||
    state.matches(`${States_1.apptQuestions}.${States_1.conditionalGxQuestions}`) ||
    state.matches(`${States_1.apptQuestions}.${States_1.apptInfoComplete}`);
const shouldShowAppointmentInfo = (state) => state.matches(States_1.apptQuestions) && !state.matches(`${States_1.apptQuestions}.${States_1.idle}`);
/**
 * Conditional GX questions should be visible if
 * - the AppointmentInfo component is visible
 * and if
 * - we're in the conditionalGxQuestions' conditionalApptGxV2Questions substate
 * or
 * - we're in the apptInfoComplete state and v2Conditionals is truthy
 * @param {StateNode} state
 * @param {Object} gx
 * @returns {Boolean}
 */
const shouldShowConditionalGxQuestions = (state, gx) => {
    return (shouldShowAppointmentInfo(state) &&
        (state.matches(`${States_1.apptQuestions}.${States_1.conditionalGxQuestions}.${States_1.conditionalApptGxV2Questions}`) ||
            (state.matches(`${States_1.apptQuestions}.${States_1.apptInfoComplete}`) &&
                gx.v2Conditionals)));
};
const propTypes = {
    service: (0, prop_types_1.instanceOf)(xstate_1.Interpreter).isRequired,
    config: (0, prop_types_1.shape)({
        emergency_disclaimer_md: (0, prop_types_1.shape)({
            enabled: prop_types_1.bool,
            markdown: (0, prop_types_1.arrayOf)(prop_types_1.string)
        }),
        emergency_disclaimer: (0, prop_types_1.shape)({
            enabled: prop_types_1.bool,
            text: prop_types_1.string
        }),
        patient_type: (0, prop_types_1.shape)({
            buttons: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
                button_text: prop_types_1.string,
                patient_type: prop_types_1.string
            }))
        }),
        recaptchaSiteKey: prop_types_1.string
    }),
    track: prop_types_1.func.isRequired,
    // supplied via `injectIntl`
    intl: (0, prop_types_1.shape)({
        formatMessage: prop_types_1.func.isRequired
    }),
    /* Properties for the appointment purpose filter controls */
    apptPurposeFilterProps: (0, prop_types_1.shape)({
        /* Specifies the minimum number of appointment purposes before the filter controls are displayed */
        minPurposesForFilter: prop_types_1.number,
        /* Labels for rendering the filter controls */
        labels: (0, prop_types_1.shape)({
            noResultsLabel: prop_types_1.string,
            purposeSearchLabel: prop_types_1.string,
            purposeSearchPlaceholderLabel: prop_types_1.string,
            visitTypeAllLabel: prop_types_1.string,
            visitTypeInPersonLabel: prop_types_1.string,
            visitTypeVirtualLabel: prop_types_1.string
        }),
        /* Function executed when the name filter changes */
        onNameFilterChange: prop_types_1.func,
        /* Function executed when the visit type filter changes */
        onVisitTypeFilterChange: prop_types_1.func,
        /* Function executed when the filters are cleared */
        onClearFilters: prop_types_1.func
    })
};
const ApptInfo = ({ service, config, track, intl, apptPurposeFilterProps }) => {
    var _a, _b, _c, _d;
    const [state, send] = (0, react_2.useService)(service);
    const { provider, patientRel, purpose, csrfToken, purposeOptionsByRel, gxPurposeOptionsByRel, gx, hidePatientRel, customerCode, productName, services, altProviders, featureFlags, appointmentEhrId, apiBaseURL, searchMatchEnabled } = state.context;
    const { aboveMd } = (0, useWindowWidth_1.default)();
    const detailedAltProviders = (0, react_1.useMemo)(() => {
        if (!altProviders) {
            return [];
        }
        return altProviders.map((providerResult) => {
            return {
                availability: providerResult.availability,
                config,
                location: providerResult.locations[0],
                provider: providerResult.provider
            };
        });
    }, [altProviders, config]);
    (0, react_1.useEffect)(() => {
        const { eventName, eventData = {} } = getTrackingByState(state);
        if (eventName) {
            track(eventName, eventData);
        }
    }, [state, track]);
    // NOTE: eslint complains because it wants an `inline` function to be passed into `useCallback`
    // since it can't tell what the internal function depends on
    /*eslint-disable react-hooks/exhaustive-deps*/
    const handleGxChange = (0, react_1.useCallback)((0, gx_handlers_1.getHandleGxChange)({ send, track, event: Actions_1.GX_QUESTION_ANSWERED }), [send, track]);
    const handleGxDone = (0, react_1.useCallback)((0, gx_handlers_1.getHandleGxDone)({ send, track, event: Actions_1.GX_PASSED }), [send, track]);
    const handleGxV1Done = (0, react_1.useCallback)((0, gx_handlers_1.getHandleGxV1Done)({ send, track }), [
        send,
        track
    ]);
    const handleConditionalGxChange = (0, react_1.useCallback)((0, gx_handlers_1.getHandleGxChange)({ send, track, event: Actions_1.CONDITIONAL_GX_QUESTION_ANSWERED }), [send, track]);
    const handleConditionalGxDone = (0, react_1.useCallback)((0, gx_handlers_1.getHandleGxDone)({ send, track, event: Actions_1.CONDITIONAL_GX_PASSED }), [send, track]);
    /*eslint-enable react-hooks/exhaustive-deps*/
    const handleClickNext = () => {
        track(Tracking_1.userEvents.APPT_INFO_NEXT, {
            patient_rel: patientRel,
            purpose: purpose.name
        });
        send(Actions_1.NEXT);
    };
    const handleCaptchaVerified = (isCaptchaVerified) => {
        send({
            type: Actions_1.CAPTCHA_VERIFIED,
            data: isCaptchaVerified
        });
    };
    const handleCaptchaCancelled = () => {
        send(Actions_1.CAPTCHA_CANCELLED);
    };
    const handleCaptchaError = () => {
        send(Actions_1.CAPTCHA_ERROR);
    };
    const handleCaptchaReset = () => {
        send(Actions_1.CAPTCHA_RESET);
    };
    const handleSelectPurpose = (purpose) => {
        track(Tracking_1.userEvents.SET_PURPOSE, {
            patient_rel: patientRel,
            purpose: purpose.name
        });
        send({
            type: Actions_1.SET_APPT_PURPOSE,
            data: {
                purpose: {
                    name: purpose.name,
                    visit_method: purpose.visit_method
                }
            }
        });
    };
    /**
     * Setting phone to empty string here will take care of displaying an alternate banner without a phone number.
     */
    const phone = (0, configUtils_1.shouldHideSchedulingHelpMessages)(config)
        ? ''
        : (0, utils_1.getMainContactNumber)(provider);
    const providerName = (0, utils_1.formatProviderName)(provider);
    const providerLocationStateFullName = (0, utils_1.getProviderLocationStateFullName)(provider);
    if (state.matches(States_1.error) ||
        state.matches(`${States_1.apptQuestions}.${States_1.conditionalGxQuestions}.${States_1.error}`)) {
        return (react_1.default.createElement(styles_1.Container, null,
            react_1.default.createElement(Banners_1.ErrorBookingBanner, { phone: phone })));
    }
    const apptInfoFormName = 'appointment-info';
    // customers with read-only Availability will not have a DBW config
    // instead use application string templates
    const appointmentInfoButtonConfig = ((_b = (_a = config.patient_type) === null || _a === void 0 ? void 0 : _a.buttons) === null || _b === void 0 ? void 0 : _b.length) > 0
        ? config.patient_type.buttons
        : [
            {
                patient_type: 'existing',
                button_text: intl.formatMessage(messages_1.default.existingPatientButtonText)
            },
            {
                patient_type: 'new',
                button_text: intl.formatMessage(messages_1.default.newPatientButtonText)
            }
        ];
    return (react_1.default.createElement(styles_1.Container, { "data-testid": "ApptInfo" },
        react_1.default.createElement(EmergencyDisclaimer_1.default, { config: config, onClose: () => {
                track('user_action.direct_book.appt_info.emergency_warning.close_warning');
            }, onClick: (event) => {
                if (event.target && event.target.href) {
                    track('user_action.direct_book.appt_info.emergency_warning.warning_link');
                }
            } }),
        state.matches(`${States_1.gxQuestions}.${States_1.apptGxQuestions}`) && (react_1.default.createElement(styles_1.GxQuestions, null,
            react_1.default.createElement(gx_1.GxUi, { name: gx.v1.name, animateInitial: true, machine: gx_1.GxEngine.createMachine({ config: gx.v1.config }), onDone: handleGxV1Done, onChange: handleGxChange }),
            state.matches(`${States_1.gxQuestions}.${States_1.apptGxQuestions}.${States_1.failedGxV1}`) && (react_1.default.createElement(Banners_1.UnavailableToScheduleBanner, { phone: phone })))),
        state.matches(`${States_1.gxQuestions}.${States_1.apptGxV2Questions}`) && (react_1.default.createElement(styles_1.GxQuestions, { "data-testid": "GxQuestions" },
            react_1.default.createElement(styles_1.GxNextQuestions, { templateVariables: {
                    provider_name: providerName,
                    provider_state: providerLocationStateFullName,
                    phone_number: phone
                }, csrfToken: csrfToken, name: gx.v2.name, steps: [gx.v2], providerId: provider.id, onChange: handleGxChange, onDone: handleGxDone, catchAllErrorBanner: react_1.default.createElement(Banners_1.ErrorBookingBanner, { phone: phone }), searchMatchEnabled: searchMatchEnabled, track: track, 
                // NOTE: XState does not update GxNextQuestions machine with updated React props.
                // The result is we do not need to clear out gx.contextualInfo updated by setConditionalGxContext for GxConditionalQuestions
                externalContext: gx.contextualInfo.context }))),
        shouldShowAppointmentInfo(state) && (react_1.default.createElement(appointment_info_1.AppointmentInfo, { patientRelTitle: ((_d = (_c = provider === null || provider === void 0 ? void 0 : provider.patient_rel_question) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.message) ? (react_1.default.createElement("span", null, provider.patient_rel_question[0].message)) : (react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.patientRelTitle, { values: {
                    display_name: providerName
                } }))), appointmentEhrId: appointmentEhrId, buttonConfig: appointmentInfoButtonConfig, onPatientRelSelect: (patientRel) => {
                track(Tracking_1.userEvents.SET_PATIENT_REL, { patient_rel: patientRel });
                send({
                    type: Actions_1.SET_PATIENT_REL,
                    data: {
                        patientRel
                    }
                });
            }, patientRel: patientRel, apptPurposeTitle: react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.appointmentPurposeTitle)), purposeOptionsByRel: gxPurposeOptionsByRel || purposeOptionsByRel, hidePatientRel: hidePatientRel, showPurpose: shouldShowApptPurpose(state), purpose: purpose, onSelectPurpose: (purpose) => handleSelectPurpose(purpose), virtualVisitConfig: {
                [VisitTypes_1.PHONE]: intl.formatMessage(messages_1.default.appointmentPhoneTitle),
                [VisitTypes_1.VIDEO]: intl.formatMessage(messages_1.default.appointmentVideoTitle),
                [VisitTypes_1.IN_PERSON]: intl.formatMessage(messages_1.default.appointmentInPersonTitle)
            }, apptPurposeFilterProps: apptPurposeFilterProps, formName: apptInfoFormName })),
        shouldShowConditionalGxQuestions(state, gx) && (react_1.default.createElement(styles_1.GxConditionalQuestions, { "data-testid": "ConditionalGxQuestions" },
            react_1.default.createElement(styles_1.GxNextQuestions, { templateVariables: {
                    provider_name: providerName,
                    provider_state: providerLocationStateFullName,
                    phone_number: phone
                }, csrfToken: csrfToken, name: gx.v2Conditionals.name, steps: [gx.v2Conditionals], providerId: provider.id, searchMatchEnabled: searchMatchEnabled, onChange: handleConditionalGxChange, onDone: handleConditionalGxDone, catchAllErrorBanner: react_1.default.createElement(Banners_1.ErrorBookingBanner, { phone: phone }), 
                /// what about when conditionalGxQuestions has noAvailability state?
                externalContext: gx.contextualInfo.context }))),
        (0, utils_apptInfo_1.showNoAvailabilityErrorBanner)(state) && (react_1.default.createElement(Banners_1.NoOnlineBookingBanner, { "data-testid": "NoOnlineBookingBanner", providerName: providerName, patientRel: patientRel, phone: phone })),
        (0, utils_apptInfo_1.showSuggestedProviders)(state) && (react_1.default.createElement(styles_1.SuggestProviderContainer, { aboveMd: aboveMd, "data-testid": "renderSuggestedProviderContainer" },
            react_1.default.createElement(styles_1.StyledSuggestedProviderHeaderText, { "data-testid": "renderSugestedProviderText" },
                react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.suggestedProvidersText))),
            react_1.default.createElement(provider_components_1.MiniProviderCardList, { createAvailabilityUrl: services.createAvailabilityUrl, createProviderUrl: services.createProviderUrl, providers: detailedAltProviders === null || detailedAltProviders === void 0 ? void 0 : detailedAltProviders.slice(0, Math.min(detailedAltProviders.length, 3)), track: track }))),
        (0, utils_apptInfo_1.showLoader)(state) && (react_1.default.createElement(styles_1.StyledNextLoader, { isMobileLoader: !aboveMd && phone, "data-testid": "nextLoader", showMessage: (0, utils_apptInfo_1.shouldShowLoaderMessage)(state) })),
        !aboveMd && phone && (react_1.default.createElement(styles_1.StyledSchedulingHelpBanner, { isErrorBannerRendered: (0, utils_apptInfo_1.showNoAvailabilityErrorBanner)(state), phone: phone, track: track })),
        react_1.default.createElement(framer_motion_1.AnimatePresence, null, state.matches(`${States_1.apptQuestions}.${States_1.apptInfoComplete}.${States_1.idle}`) && (react_1.default.createElement(MountScroller_1.default, { alignToTop: (0, configUtils_1.isDirectBookRenderedInDrawer)(config, featureFlags), delay: 120 }, (ref) => {
            return (react_1.default.createElement(NextBtn_1.default, { ref: ref, onClick: handleClickNext, type: "submit", form: apptInfoFormName }));
        }))),
        state.matches(`${States_1.apptQuestions}.${States_1.apptInfoComplete}.${States_1.verifyingCaptcha}`) && (react_1.default.createElement(Recaptcha_1.RecaptchaModal, { onCancel: handleCaptchaCancelled, onError: handleCaptchaError, onVerified: handleCaptchaVerified, siteKey: config.recaptchaSiteKey, customerCode: customerCode, productName: productName, apiBaseURL: apiBaseURL })),
        state.matches(`${States_1.apptQuestions}.${States_1.apptInfoComplete}.${States_1.verifyingCaptchaError}`) && (react_1.default.createElement(RecaptchaErrorModal_1.default, { onClose: handleCaptchaCancelled, onReset: handleCaptchaReset }))));
};
ApptInfo.propTypes = propTypes;
exports.default = (0, intl_1.injectIntl)(ApptInfo);
//# sourceMappingURL=ApptInfo.js.map